import {
  prevPageView,
  readingSwitchData,
} from '../../../common/util/tracking/tiara';
import {sendHomeEvent, sendHomeViewImp} from '../../common/tracking';
import {
  IBigOverContent,
  IMainContent,
  IMainItemHandler,
  IMainParams,
} from '../../common/type';

export default function useMainListEventHandler() {
  const handleClickBigContent: IMainItemHandler<IBigOverContent> = params => {
    sendHomeEvent({
      actionName: getActionName(params.item.isAdminSection),
      action: 'click',
      customProps: {
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
    });
    !params.content.isEvent && setLastClickLog(params);
  };

  const handleClickContent: IMainItemHandler = params => {
    sendHomeEvent({
      actionName: getActionName(params.item.isAdminSection),
      action: 'click',
      customProps: {
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
    });
    !params.content.isEvent && setLastClickLog(params);
  };

  const sendViewImpBigContent: IMainItemHandler<IBigOverContent> = params => {
    sendHomeViewImp({
      customProps: {
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
      viewImpContents: {
        name: 'card',
      },
    });
  };

  const sendViewImpContent: IMainItemHandler = params => {
    sendHomeViewImp({
      customProps: {
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
      viewImpContents: {
        name: 'card',
      },
    });
  };

  const handleClickPromotionVideo: IMainItemHandler<IBigOverContent> = ({
    item,
    content,
    index,
  }) => {
    sendHomeEvent({
      actionName: getActionName(item.isAdminSection),
      action: 'click',
      customProps: {
        event_layer: 'section',
        content_id: content.id,
        ordnum: index + 1,
      },
    });
  };

  const handleClickPromotionVideoMute = (
    isMute: boolean,
    params: IMainParams
  ) => {
    sendHomeEvent({
      actionName: 'video_sound',
      action: 'click',
      customProps: {
        is_sound_on: isMute ? 'N' : 'Y',
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
    });
  };

  const handleClickPromotionVideoPlay: IMainItemHandler<
    IBigOverContent
  > = params => {
    sendHomeEvent({
      actionName: 'video',
      action: 'play',
      customProps: {
        ...getCommonAdditionalProps(params.content),
        ...getCommonProps(params),
      },
    });
  };

  return {
    handleClickBigContent,
    handleClickContent,
    sendViewImpBigContent,
    sendViewImpContent,
    handleClickPromotionVideo,
    handleClickPromotionVideoMute,
    handleClickPromotionVideoPlay,
  };
}

function setLastClickLog({item, content, index}: IMainParams) {
  readingSwitchData.customProps = {
    last_click_page: prevPageView.page,
    last_click_section: prevPageView.section,
    last_click_action_name: getActionName(item.isAdminSection),
    last_click_content_id: content.id,
    last_click_cardgroup_id: content.operationId,
    last_click_placement: item.placement,
    last_click_ordnum: index + 1,
  };
}

function getCommonAdditionalProps({
  operationId,
  landingType,
}: IBigOverContent | IMainContent) {
  return {
    cardgroup_id: operationId,
    landing_type: landingType,
  };
}

function getCommonProps({item, content, index}: IMainParams) {
  return {
    placement: item.placement,
    content_id: content.id,
    event_layer: 'section',
    ordnum: index + 1,
  };
}

const getActionName = (isAdminSection: boolean) =>
  isAdminSection ? 'card' : 'content';
